<template>
  <b-modal id="modal-bronlist" hide-footer @shown="Shoved1" size="lg" style="float: right!important;" @hidden="Hide()">
  </b-modal>
</template>

<script>
export default {
 name: "Bronlist",
 data() {
     return {
     }
 },
 methods: {
 },
}
</script>